import { Injectable } from '@angular/core';
import { TokenALO } from '../Models/TokenALO';
import { EmpresaPresencia } from '../Models/EmpresaPresencia';
import { Usuario } from '../Models/Usuario';
import { MbscLocale, localeEs } from '@mobiscroll/angular';
import { Parametro } from '../Models/Parametro';
import { PeticionPendiente } from '../Models/PeticionPendiente';
import { ArticuloDTO, TipoTarifaDTO } from '../Models/ApiV2/ArticuloDTO';
import { AgenteTerceroDTO, ClienteDTO, ProveedorDTO, agenteDTO } from '../Models/ApiV2/Terceros';
import { DTO_Prediccion } from '../Models/MeteoDTO';
import { AlbaranDTO, DocumentoApp, EstadoEntidadAsignacionDTO, EstadoEntidadDTO, FacturaDTO, FacturaSimplificadaDTO, PedidoDTO, PresupuestoDTO } from '../Models/ApiV2/DocumentoDTO';
import { EmpresaALO } from '../Models/EmpresaALO';
import { enumPerfilAcceso, enumTipoOperacion, eTipoFicheroTerceros } from 'src/GlobalConf';
import { CredencialAccesoFirebase } from '../Models/CredencialAccesoFirebase';
import { FamiliaArticuloDTO } from '../Models/ApiV2/FamiliaArticuloDTO';
import { TiposIvaDTO } from '../Models/ApiV2/TiposIvaDTO';
import { CategoriaDTO } from '../Models/ApiV2/CategoriaDTO';
import { MarcaDTO } from '../Models/ApiV2/MarcaDTO';
import { ModeloDTO } from '../Models/ApiV2/ModeloDTO';
import { TiposRetencionDTO } from '../Models/ApiV2/TiposRetencionDTO';
import { SesionActual } from '../Models/SesionActual';

@Injectable({
  providedIn: 'root'
})
export class VariablesGlobalesService {
  public loginCorrecto: boolean;
  public idiomaSeleccionado: string;
  public localeMbs: MbscLocale = localeEs
  public claveEncriptacion: string = "AutoVenta";
  public empresaActual: EmpresaPresencia | EmpresaALO;
  public empresaAnterior: EmpresaPresencia | EmpresaALO;
  /**Indica el usuario que esta utilizando la aplicación */
  public usuarioActual: Usuario;
  public plataforma: string
  public mostrarTabs: boolean = false
  public tagsEmpresa: string[];

  public parametros: Parametro[]
  vendedores: agenteDTO[];
  vendedorActual: agenteDTO;
  conInternet: boolean;
  public codigoMonedaALO: string = 'EUR';
  public idiomaALO: string;
  public localeMoneda: string = 'es-ES';

  public listaPedidosVenta: PedidoDTO[] = []
  public listaPedidosCompra: PedidoDTO[] = []

  public listaFacturasVenta: FacturaDTO[] = []
  public listaFacturasCompra: FacturaDTO[] = []
  public listaFacturasSimplificadas: FacturaSimplificadaDTO[] = []

  public listaAlbaranesVenta: AlbaranDTO[] = []
  public listaAlbaranesCompra: AlbaranDTO[] = []

  public listaPresupuestos: PresupuestoDTO[] = []

  public listaArticulos: ArticuloDTO[] = []
  public listaClientes: ClienteDTO[] = []
  public listaClientesRecientes: ClienteDTO[] = []
  public listaArticulosRecientes: ArticuloDTO[] = []
  public listaProveedores: ProveedorDTO[] = [];
  public listaProveedoresRecientes: ProveedorDTO[] = [];

  public documentoActual: DocumentoApp

  public documentoEnCurso: boolean = false



  public prediccion: DTO_Prediccion;
  public dispositivoConInternet: boolean;
  public conexionBaseDeDatos: boolean;
  public doLoginOffline: boolean;

  public peticionesPendientes: PeticionPendiente[];
  public DecimalesEnUnidades: string = '0'
  public DecimalesEnMoneda: string = '0'
  public optionsInputUnidades

  public googleLogin: boolean;
  public googleListaCalendarios: any[]

  public cargaInicialIndexDB: boolean = false

  public perfilAcceso: enumPerfilAcceso;
  public perfilAccesoAnterior: enumPerfilAcceso;
  public tabSeleccionadaHome: string;

  public leyendoArticulos: boolean = false;
  public leyendoClientes: boolean = false;
  public leyendoPedidosVenta: boolean = false;
  public leyendoPedidosCompra: boolean = false;
  public leyendoFacturasVenta: boolean = false;
  public leyendoFacturasCompra: boolean = false;
  public leyendoFacturasSimplificadas: boolean = false;
  public leyendoAlbaranesVenta: boolean = false;
  public leyendoAlbaranesCompra: boolean = false;
  public leyendoPresupuestos: boolean = false;
  public leyendoProveedores: boolean = false;

  public recuerdameLogin: boolean = false;
  public vistaGrid: boolean = false;
  public archivosSubidos: any;
  public gridView: { data: ArticuloDTO[]; total: number; };
  public credencialAcceso: CredencialAccesoFirebase;
  public mostrarLogin: boolean = true; // Para cuando se inicie por credencial
  public margenSuperior: number = 50;

  public screenHeight: number;
  public screenWidth: number;

  public elementosPipeArticulos: number;
  public elementosPipeTerceros: number;
  public elementosPipeFacturas: number = 0;

  public newColorScheme: string;
  public colorPrimario: string;
  public colorSecundario: string;

  public segmentSeleccionadoClientes: string;
  public segmentSeleccionadoArticulos: string;
  public segmentSeleccionadoProveedores: string;

  public presupuestosTercero: PresupuestoDTO[];
  public presupuestosTerceroNumero: number = 0;

  public albaranesTercero: AlbaranDTO[];
  public albaranesTerceroNumero: number = 0;

  public facturasTercero: FacturaDTO[];
  public facturasTerceroNumero: number = 0;

  public pedidosTercero: PedidoDTO[];
  public pedidosTerceroNumero: number = 0; leyendoPresupuestosCompra: any;
  public estadoCorrectoFacturasTerceroIcono: boolean = false;
  public estadoInCorrectoFacturasTerceroIcono: boolean = false;
  public fechasRangoDocumentosTercero: any[];
  public estadoInCorrectoPedidosTerceroIcono: boolean = false;
  public estadoCorrectoPedidosTerceroIcono: boolean = false;
  public estadoInCorrectoPresupuestosTerceroIcono: boolean = false;
  public estadoCorrectoPresupuestosTerceroIcono: boolean = false;

  familiasArticulos: FamiliaArticuloDTO[];
  categoriasArticulos: CategoriaDTO[];
  tiposTarifasPrecios: TipoTarifaDTO[];
  tiposTarifasPreciosCompra: TipoTarifaDTO[];
  tiposTarifasDescuentos: TipoTarifaDTO[];
  tiposIVA: TiposIvaDTO[];
  marcasArticulos: MarcaDTO[];
  modelosArticulos: ModeloDTO[];
  tiposRetencionServicios: TiposRetencionDTO[];

  public estadosPedidosALO: EstadoEntidadDTO[] = [];

  public tipoOperacionDocumentoSeleccionada: enumTipoOperacion;
  public tipoTerceroSeleccionado: eTipoFicheroTerceros;
  appSegundoPlano: boolean;
  metodoAcceso: 'enlaceALO'|'login';
  sesionActual: SesionActual;

  constructor() {
    this.dispositivoConInternet = false;
    this.conexionBaseDeDatos = false;
    this.doLoginOffline = false;
    this.optionsInputUnidades = {
      digitGroupSeparator: '.',
      decimalCharacter: ',',
      minimumValue: '0',
      decimalPlaces: 2
    }
    this.peticionesPendientes = [];
    this.googleListaCalendarios = [];
    this.margenSuperior = 50;
    //this.credencialAcceso = new CredencialAccesoFirebase();
    //this.credencialAcceso.origen = 'AloSuite';

  }
}
